import React from 'react'
import {FAQ} from 'Event/FAQs'
import Body from 'Event/template/Panels/Dashboard/FAQs/FaqList/Card/Body'
import {Draggable} from 'react-beautiful-dnd'
import {useEditMode} from 'Event/EditModeProvider'

export const DEFAULT_DESCRIPTION = ''
export const DEFAULT_TITLE = 'FAQ'
export const DEFAULT_BACK_TO_DASHBOARD_TEXT = 'Back to Dashboard'
export const DEFAULT_BACK_TO_DASHBOARD_TEXT_COLOR = '#000000'

type FaqProps = {
  index: number
  id: string
  faq: FAQ
  className?: string
}

export default function Card(props: FaqProps) {
  const {id, index, faq} = props

  const isEditMode = useEditMode()

  if (!isEditMode) {
    return (
      <div aria-label="faq" className={props.className}>
        <Body id={id} faq={faq} />
      </div>
    )
  }

  return (
    <Draggable draggableId={id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          aria-label="faq"
          className={props.className}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Body id={id} faq={faq} answerVisible />
        </div>
      )}
    </Draggable>
  )
}
